import React, { useContext, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import Utils from "../utils/Utils";
import "../styles/style.css";

function BookReservation() {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    name: "",
    phone: "",
    email: "",
    chairs: "",
    message: "",
    bookingDate: "",
    bookingTime: "",
    status: "Approved",
  });
  const {
    addNewReservartion,
    reservationLoading,
    tokenData,
    fetchNewReservations,
    fetchFutureReservations,
    todaysReservationList,
    upcomingwithtodaysReservationList,
    foodpageReservSettings,
    reservFoodpageTiming,
    closureList,
    upComingHolidays,
  } = useContext(AppContext);
  const [isError, setIsError] = useState(false);
  const [timeIntervals, setTimeIntervals] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhonenumber = (number) => {
    const phoneRegex = /^[0-9]*$/;
    if (phoneRegex.test(number.trim())) {
      setValues((prev) => ({ ...prev, phone: number.trim() }));
    }
  };

  const handleChairs = (value) => {
    const numberRegex = /^[0-9]*$/;
    if (numberRegex.test(value)) {
      setValues((prev) => ({ ...prev, chairs: value }));
    }
  };

  const getClosureWindowsForDate = (date) => {
    if (!Array.isArray(closureList) || closureList.length === 0) return [];

    const dateObj = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dateObj.getTime())) return [];

    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    const targetDateStr = `${dateObj.getFullYear()}-${pad(
      dateObj.getMonth() + 1
    )}-${pad(dateObj.getDate())}`;

    return closureList
      .filter((c) => c.status === "Active")
      .map((c) => {
        const startDateStr = c.startTime.slice(0, 10);
        const endDateStr = c.endTime.slice(0, 10);
        const startTimeStr = c.startTime.slice(11, 16);
        const endTimeStr = c.endTime.slice(11, 16);

        if (targetDateStr < startDateStr || targetDateStr > endDateStr) {
          return null;
        }

        let dayStart;
        let dayEnd;

        if (startDateStr === endDateStr) {
          dayStart = startTimeStr;
          dayEnd = endTimeStr;
        } else if (targetDateStr === startDateStr) {
          dayStart = startTimeStr;
          dayEnd = "23:59";
        } else if (targetDateStr === endDateStr) {
          dayStart = "00:00";
          dayEnd = endTimeStr;
        } else {
          dayStart = "00:00";
          dayEnd = "23:59";
        }

        return { startTime: dayStart, endTime: dayEnd };
      })
      .filter(Boolean);
  };

  const getReservTiming = (date) => {
    if (!reservFoodpageTiming) return;

    setValues((prev) => {
      const isDateChanged = prev.bookingDate && prev.bookingDate !== date;

      return {
        ...prev,
        bookingDate: date,
        bookingTime: isDateChanged ? "" : prev.bookingTime,
      };
    });

    const dayValue = Utils.getDayOfWeek(date);
    const todaysTiming = reservFoodpageTiming[dayValue];

    const intervalDuration =
      typeof foodpageReservSettings?.timeinterval === "string"
        ? parseInt(foodpageReservSettings?.timeinterval, 10)
        : 30;

    if (!todaysTiming || todaysTiming.length === 0) {
      setTimeIntervals([]);
      return;
    }

    const allIntervals = todaysTiming.flatMap((time) => {
      return Utils.getReservIntervals(
        time.openingTime,
        time.closingTime,
        intervalDuration
      );
    });

    const closureWindows = getClosureWindowsForDate(date, closureList);

    if (!closureWindows || (closureWindows && closureWindows.length == 0)) {
      setTimeIntervals(allIntervals);
      return;
    }

    const filteredIntervals = allIntervals.filter((time) => {
      return closureWindows.every((win) => {
        const start = win.startTime;
        const end = win.endTime;
        return time < start || time > end;
      });
    });

    setTimeIntervals(filteredIntervals);
  };

  const isBookingValid = () => {
    const bookingDate = values?.bookingDate;
    const bookingTime = values?.bookingTime;
    const now = new Date();

    const bookingDateNew = new Date(bookingDate);

    const isSameDay =
      now.getDate() === bookingDateNew.getDate() &&
      now.getMonth() === bookingDateNew.getMonth() &&
      now.getFullYear() === bookingDateNew.getFullYear();

    if (isSameDay) {
      const [hours, minutes] = bookingTime.split(":").map(Number);

      const bookingDateTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes
      );

      return bookingDateTime < now;
    }

    return false;
  };

  const validateFields = () => {
    if (
      values.name.length === 0 ||
      values.phone.length === 0 ||
      values.email.length === 0 ||
      values.chairs.length === 0 ||
      values.bookingDate.length === 0 ||
      values.bookingTime.length === 0
    ) {
      setIsError(true);
      return true;
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateFields();

    if (isValid == true) return;

    const isValidBookingTIme = isBookingValid();

    if (isValidBookingTIme === true) {
      toast.error(`Please select a valid time!`);
      return;
    }

    const parsedChairCount =
      foodpageReservSettings?.maxPartySize &&
      typeof foodpageReservSettings?.maxPartySize === "string"
        ? Number(foodpageReservSettings?.maxPartySize)
        : foodpageReservSettings?.maxPartySize ?? 0;

    const parsedValueChairCount =
      values?.chairs && typeof values?.chairs === "string"
        ? Number(values?.chairs)
        : values?.chairs ?? 0;

    if (parsedChairCount < parsedValueChairCount) {
      toast.error(
        `Party size is must be less than ${foodpageReservSettings?.maxPartySize}`
      );
      return;
    }
    if (parsedValueChairCount <= 0) {
      toast.error("Please choose minimum party size!");
      return;
    }

    const { bookingDate, bookingTime, ...rest } = values;

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();

    const [hours, minutes] = bookingTime.split(":").map(Number);
    const dateTime = new Date(year, month, day, hours, minutes, 0);

    const formattedTime = dateTime.toTimeString().split(" ")[0];

    const bookingMerged = `${bookingDate} ${formattedTime}`;

    const siteStorageURL = localStorage.getItem("siteURL");
    const siteURL = `${siteStorageURL}/view-reservation?reserv=`;

    const payload = {
      ...rest,
      userID: 0,
      shopmessage: "",
      bookingTime: bookingMerged,
      advancePayment: "",
      advanceAmount: "",
      amountStatus: "",
      paymentMethod: "",
      transactionID: "",
      baseUrl: siteURL,
      source: "NestJS",
    };

    const headers = { "x-shopToken": tokenData?.shopCustomToken };
    await addNewReservartion(payload, {
      onSuccess: async () => {
        await fetchNewReservations(tokenData?.shopCustomToken);
        await fetchFutureReservations(tokenData?.shopCustomToken);
        await todaysReservationList(tokenData?.shopCustomToken);
        await upcomingwithtodaysReservationList();
        setTimeout(() => {
          toast.success(
            `Reservation created & ${values?.status} successfully!`
          );
          navigate("/table-enquiry-list");
        }, 1000);
      },
      onFailed: (err) => {
        console.log(err);
        toast.error("Creation Failed!");
      },
      headers: headers,
    });
  };

  const today = new Date().toISOString().split("T")[0];
  const maxParty = foodpageReservSettings?.maxPartySize ?? 50;
  const hasHolidays =
    Array.isArray(upComingHolidays) && upComingHolidays.length > 0;

  return (
    <MasterLayout>
      <div className="rs-book">
        <header className="rs-book__header">
          <button
            type="button"
            className="rs-book__back"
            onClick={() => navigate(-1)}
          >
            <MdKeyboardArrowLeft /> Back
          </button>
          <h1 className="rs-book__title">Add new reservation</h1>
          {/* <p className="rs-book__subtitle">
            Create a booking with guest details, party size, and status.
          </p> */}
        </header>

        <div className="rs-book__layout">
          <form className="rs-book__form" onSubmit={handleSubmit} noValidate>
            <section className="rs-book-card">
              <h2 className="rs-book-card__title">Booking information</h2>
              <div className="rs-book-grid">
                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="bookingDate">
                    Booking date
                  </label>
                  <input
                    type="date"
                    id="bookingDate"
                    name="bookingDate"
                    className="rs-book-input"
                    value={values.bookingDate}
                    onChange={(e) => getReservTiming(e.target.value)}
                    min={today}
                  />
                  {isError && values.bookingDate.length === 0 && (
                    <p className="rs-book-error">Booking date is required</p>
                  )}
                </div>

                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="bookingTime">
                    Booking time
                  </label>
                  <select
                    id="bookingTime"
                    name="bookingTime"
                    className="rs-book-input rs-book-select"
                    value={values.bookingTime}
                    onChange={handleChange}
                    disabled={!values.bookingDate}
                  >
                    <option value="">
                      {values.bookingDate
                        ? "Choose booking time"
                        : "Select a date first"}
                    </option>
                    {timeIntervals &&
                      timeIntervals.length !== 0 &&
                      timeIntervals.map((interval, index) => (
                        <option value={interval} key={`${interval}-${index}`}>
                          {interval ? Utils.convertTiming(interval) : "N/A"}
                        </option>
                      ))}
                  </select>
                  {isError && values.bookingTime.length === 0 && (
                    <p className="rs-book-error">Booking time is required</p>
                  )}
                  {values.bookingDate &&
                    Array.isArray(timeIntervals) &&
                    timeIntervals.length === 0 && (
                      <p className="rs-book-hint rs-book-hint--warn">
                        No available times for this date
                      </p>
                    )}
                </div>

                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="chairs">
                    Party size
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    id="chairs"
                    name="chairs"
                    className="rs-book-input"
                    value={values.chairs}
                    onChange={(e) => handleChairs(e.target.value)}
                    maxLength={String(maxParty).length + 1}
                    placeholder="e.g. 4"
                  />
                  <p className="rs-book-hint">Maximum party size is {maxParty}</p>
                  {isError && values.chairs.length === 0 && (
                    <p className="rs-book-error">Party size is required</p>
                  )}
                </div>

                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="status">
                    Status
                  </label>
                  <select
                    id="status"
                    name="status"
                    className="rs-book-input rs-book-select"
                    value={values.status}
                    onChange={handleChange}
                  >
                    <option value="Requested">Requested</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>
            </section>

            <section className="rs-book-card">
              <h2 className="rs-book-card__title">Guest information</h2>
              <div className="rs-book-grid">
                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="name">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="rs-book-input"
                    value={values.name}
                    onChange={handleChange}
                    autoComplete="name"
                    placeholder="Guest name"
                  />
                  {isError && values.name.length === 0 && (
                    <p className="rs-book-error">Name is required</p>
                  )}
                </div>

                <div className="rs-book-field">
                  <label className="rs-book-label" htmlFor="phone">
                    Phone number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="rs-book-input"
                    value={values.phone}
                    onChange={(e) => handlePhonenumber(e.target.value)}
                    autoComplete="tel"
                    placeholder="Phone number"
                  />
                  {isError && values.phone.length === 0 && (
                    <p className="rs-book-error">Phone number is required</p>
                  )}
                </div>

                <div className="rs-book-field rs-book-field--full">
                  <label className="rs-book-label" htmlFor="email">
                    Email address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="rs-book-input"
                    value={values.email}
                    onChange={handleChange}
                    autoComplete="email"
                    placeholder="guest@email.com"
                  />
                  {isError && values.email.length === 0 && (
                    <p className="rs-book-error">Email address is required</p>
                  )}
                </div>

                <div className="rs-book-field rs-book-field--full">
                  <label className="rs-book-label" htmlFor="message">
                    Custom message
                    <span className="rs-book-optional">Optional</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    className="rs-book-input rs-book-textarea"
                    value={values.message}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Notes for the reservation…"
                  />
                </div>
              </div>
            </section>

            <div className="rs-book__actions">
              <button
                type="button"
                className="rs-book-btn rs-book-btn--ghost"
                onClick={() => navigate(-1)}
                disabled={reservationLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rs-book-btn rs-book-btn--primary"
                disabled={reservationLoading}
              >
                {!reservationLoading ? (
                  "Add reservation"
                ) : (
                  <PulseLoader color="#fff" size={10} />
                )}
              </button>
            </div>
          </form>

          <aside className="rs-book__aside" aria-label="Upcoming closures">
            <section className="rs-book-card rs-book-card--aside">
              <h2 className="rs-book-card__title">Upcoming closures</h2>
              {hasHolidays ? (
                <ul className="rs-book-closures">
                  {upComingHolidays.map((exc, idx) => (
                    <li
                      className="rs-book-closure"
                      key={exc?.id ?? `${exc?.startTime}-${idx}`}
                    >
                      <p className="rs-book-closure__reason">
                        {exc?.reason ?? "Closure"}
                      </p>
                      <p className="rs-book-closure__time">
                        {exc?.startTime && exc?.endTime
                          ? `${Utils.parseAndFormat2(
                              exc.startTime
                            )} – ${Utils.parseAndFormat2(exc.endTime)}`
                          : "N/A"}
                      </p>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="rs-book-empty">No upcoming closures</p>
              )}
            </section>
          </aside>
        </div>
      </div>
    </MasterLayout>
  );
}

export default BookReservation;
